import styled from "styled-components";

export const Content = styled.div`
    .content_modal {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 200px;
    }

    .content_paper {
        position: absolute;
        width: 400;
        color: '#3e3e';
        background-color: '#e0e0e0';
        border: '2px solid #3e3e';
    }
`;

export const Line = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-around;
    padding-bottom: 10px;

    .first {
        flex-grow: 1;
    }
`;

export const IconButton = styled.div`
    cursor: pointer;
`;
